import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carolina M.',
    role: 'Gerente de Marketing, 34 años',
    quote: "Llevaba años pensando que era 'normal' terminar el día con la panza como un globo. En 3 días aplicando los consejos de la página 12, mi digestión cambió por completo. Puedo usar mis pantalones ajustados todo el día.",
    rating: 5
  }, {
    name: 'Valentina R.',
    role: 'Diseñadora Gráfica, 29 años',
    quote: 'Trabajo sentada 9 horas al día. El dolor abdominal era insoportable a las 4pm. La técnica de desinflamación rápida me salvó la vida. Ahora me siento ligera incluso después de almorzar.',
    rating: 5
  }, {
    name: 'Sofía L.',
    role: 'Abogada, 41 años',
    quote: 'No tengo tiempo para dietas complicadas ni jugos raros. Esta guía va al grano. Simple, directa y funciona. Me siento con más energía y mi ropa me queda mejor que hace 5 años.',
    rating: 5
  }];
  return <Section id="testimonials" background="white" data-id="element-204">
      <div className="text-center mb-16" data-id="element-205">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A3B32] mb-4" data-id="element-206">
          Historias de Transformación
        </h2>
        <p className="text-[#5D5D5D]" data-id="element-207">
          Mujeres reales que recuperaron su comodidad y confianza.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-208">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-[#F0FDFA] p-8 rounded-2xl relative" data-id="element-209">
            <Quote className="absolute top-6 right-6 text-[#5EEAD4]/40 w-10 h-10" data-id="element-210" />

            <div className="flex space-x-1 mb-4" data-id="element-211">
              {[...Array(t.rating)].map((_, i) => <Star key={i} size={16} className="fill-[#14B8A6] text-[#14B8A6]" data-id="element-212" />)}
            </div>

            <p className="text-[#4A3B32] mb-6 italic leading-relaxed" data-id="element-213">
              "{t.quote}"
            </p>

            <div className="border-t border-[#5EEAD4]/20 pt-4" data-id="element-214">
              <p className="font-bold text-[#4A3B32]" data-id="element-215">{t.name}</p>
              <p className="text-sm text-[#5D5D5D]" data-id="element-216">{t.role}</p>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}